// CC-351 — whether this login may see Terms applications (owners, platform admins, Terms viewer emails).
import { useEffect, useState } from "react";
import api from "@/lib/api";

export const PUBLIC_TERMS_BASE = "https://currentcontrolhq.com/terms/apply";

export function useTermsAccess(user) {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    if (!user) { setAllowed(false); return; }
    api.get("/terms/access").then(({ data }) => setAllowed(!!data.allowed)).catch(() => setAllowed(false));
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return allowed;
}

// Terms pass A — resolved tenant (platform admins default to mre-swmo) + review/approve rights.
export function useTermsScope() {
  const [scope, setScope] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/terms/scope").then(({ data }) => setScope(data)).catch((e) => setErr(String(e?.response?.data?.detail || e.message)));
  }, []);
  return { scope, err };
}
